import React, { useEffect, useState } from "react";
import { makeSideBarActive } from "../../utils/ellowutils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import ConfirmationModal from '../../modal/confirmation/confirmationModal';
import AppliedCandidates from "./appliedCandidate";
import { useLocation } from 'react-router-dom';
import { getPositionsDetails ,  getAppliedCandidate, updateLossCountAPI , updatePositionAPI } from './services';
import { EditorState, convertToRaw, convertFromRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { useNavigate } from 'react-router-dom';
import NotificationAlert from "../../compopnents/notification";
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";


function PositionDetails() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);
  
  const location = useLocation();
  const {  jobId }: any = location.state || ''
  const { positionName }: any = location.state || ''
  const { companyName } :any = location.state || ''
  const loginId = localStorage.getItem('loginId')
 
  const navigate = useNavigate()
  const [modal , setModal] = useState<boolean>(false)
  const [message , setMessage] = useState<any>()
  const [companyPositionName , setCompanyPositioName] = useState<string>()
  const [ Company , setCompany] = useState<string>()
  const [notification, setNotification] = useState<boolean>(false)
  const [value , setValue] = useState<any>()
  const [jobsId , setJobsId] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
  const [jobStatus, setJobStatus] = useState<number>()
  const [appliedResources, setAppliedResources] = useState([])
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: string , experienceRange: {max: number, min: number} , contractDuration : string , contractStartDate: string , minimumBudget: string , maximumBudget: string ,
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}],
    closedCount: string , jobDescription : string, jobResponsibilities : string , priority: string, lossCount: number , postPosition: {companyId: string , companyName: string},
    supportingDocument: string , title: string , currencyType: string , jobType: string,
  }>({
    resourceCount: "", experienceRange: {max: 20, min: 0} , contractDuration: "" , contractStartDate: "" , minimumBudget: "" , maximumBudget: "" ,
    billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}],
    closedCount: "0", jobDescription: "", jobResponsibilities: "" , priority: "", lossCount:0 , postPosition: {companyId: "" , companyName: ""},
    supportingDocument: "" , title: "" , currencyType: "" , jobType: ""
  })

  let BreadcrumsValues = ['Positions', companyPositionName + ' - ' + Company ]

  useEffect(() => {
    
    setCompanyPositioName(positionName)
    setCompany(companyName)
    getPositionDetails(jobId)
    getAppliedCandidates(jobId)
    setJobsId(jobId)
    viewedpageMixpanel();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const getPositionDetails = (jobId: string) => {
    getPositionsDetails(jobId).then(
      (response) => { 
        if (response && response.status === 1) {        
          setJobMetadata(response.data[0].job_metadata) 
          setJobStatus(response.data[0].job_status)            
        }
      }
    )
  }

  const getAppliedCandidates = (jobId: string) => {
    getAppliedCandidate(jobId).then((resp: any) => {
      if( resp && resp.status === 1 ){ 
        setAppliedResources(resp.data)
      }
    }) 
  }

  const convert = (item:any) => {

    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
           let abd = draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(item))).getCurrentContent()))
           let strippedHtml = abd.replace(/<[^>]+>/g, '');
           return strippedHtml

        }
        catch (e) {
          return item
        }

      }
    }
  }
  
  const updateLossCount = (data: any) => {
    const newData = {
      userLoginId: loginId,
      jobId: jobId,
      jobMetadata: {
        lossCount:parseInt(data)
      }
    }
    updateLossCountAPI(newData).then((response) => {
      if(response && response.status === 1){
         getPositionDetails(jobId)

      }
     })
  }

  const editPosition = () => { 
    getPositionsDetails(jobsId).then(
      (response) => {    
        if (response && response.status === 1) {          
         navigate('/createPositions' , {state : {jobMetadata: response.data[0].job_metadata , jobId:response.data[0].job_id, jobStatus: response.data[0].job_status , publishKey: 'update'}}) 
        }
      }
    )
  }

  const deletePosition = () => {
    let value = {
      "loginId":loginId,
      "jobId": jobsId,
      "userLoginId":  loginId,
      "action": "delete",
      "submittedBy": "CUSTOMER"
    }
    setValue(value)
    setModal(true)
  }
  
  const closePosition = () => { 
    let value = {
      "loginId":loginId,
      "jobId": jobsId,
      "userLoginId":  loginId,
      "action": "close",
      "submittedBy": "CUSTOMER"

    }
    setValue(value)
    setModal(true)
  }

  const reopenPosition = () => { 
    let value = {
     "loginId":loginId,
     "jobId": jobsId,
     "userLoginId":  loginId,
     "action": "reopen",
     "submittedBy": "CUSTOMER"

    }
    setValue(value)
    setModal(true)
  }

  const updatePosition = (value:string) => { 
      switch (value) {
        case 'delete':
          return deletePosition();
        case 'close':
          return closePosition();
        case 'edit':
          return editPosition();
        case 'reopen':
          return reopenPosition();
      }
  }

  const submit = () => {
    updatePositionAPI(value).then((response) => {
      if(response && response.status === 1)  
      { 
        if(value.action === "delete")
        {
          setMessage("Position deleted")
          displayNotification()
          mixpanelData('New MT - Position deleted', {
            'distinct_id': localStorage.getItem('Email'),
            'Job id': value.jobId,
            'Position name': response && response.data[0].job_metadata.title,
            'Job role': response && response.data[0].job_metadata.jobRole.name,
            'Company name': response && response.data[0].job_metadata.postPosition.companyName,
            'Allocated to':response && response.data[0].allocatedToName,
            'Priority': response && response.data[0].job_metadata.priority === 1 ? 'Cold' : response && response.data[0].job_metadata.priority === 3 ? 'Hot' : 'Warm',
            'Resource number': response && response.data[0].job_metadata.resourceCount,
            'Experience': response && JSON.stringify(response.data[0].job_metadata.experienceRange.min) + ' - '+JSON.stringify(response.data[0].job_metadata.experienceRange.max)+ ' Years',
            'Type of job': response && response.data[0].job_metadata.jobType,
            'Core skills': response && response.data[0].job_metadata.coreSkills && response.data[0].job_metadata.coreSkills.length > 0 && response.data[0].job_metadata.coreSkills.map((item: any) => item.skillName),
            'Other skills' : response && response.data[0].job_metadata.otherSkills && response.data[0].job_metadata.otherSkills.length > 0 && response.data[0].job_metadata.otherSkills.map((item: any) => item.skillName),
            'Work location' : response && response.data[0].job_metadata.workLocation,
            'Contract period' : response && response.data[0].job_metadata.contractDuration,
            'Start date': response && response.data[0].job_metadata.contractStartDate && new Date(response && response.data[0].job_metadata.contractStartDate).toDateString(),
            'Active positions': response && parseInt(response.data[0].job_metadata.resourceCount) - parseInt(response.data[0].job_metadata.closedCount),
            'Company id': response && response.data[0].company_id,
            'Minimum budget' : `${response && response.data[0].job_metadata.minimumBudget} ${response && response.data[0].job_metadata && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
            'Maximum budget' : `${response && response.data[0].job_metadata.maximumBudget} ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
            
          })
        } 
        if(value.action === "reopen"){
          // mixpanelData('New MT - Position Reopened', {
          //   'distinct_id': localStorage.getItem('Email'),
          //   'Job id': value.jobId,
          //   'Position name': response && response.data[0].job_metadata.title,
          //   'Job role': response && response.data[0].job_metadata.jobRole.name,
          //   'Company name': response && response.data[0].job_metadata.postPosition.companyName,
          //   'Allocated to': response && response.data[0].allocatedToName,
          //   'Active position': response && response.data[0].job_metadata.resourceCount - response.data[0].job_metadata.closedCount,
          //   'Company id': response && response.data[0].company_id,
          //   'Minimum budget' : response && response.data[0].job_metadata.minimumBudget + ' ' + value.jobMetadata && value.jobMetadata.currencyType + '/' + value.jobMetadata && value.jobMetadata.currencyType,
          //   'Maximum budget' : response && response.data[0].job_metadata.maximumBudget + ' ' + value.jobMetadata && value.jobMetadata.currencyType + '/' + value.jobMetadata && value.jobMetadata.currencyType

          // }) 
          mixpanelData('New MT - Position Reopened', {
            'distinct_id': localStorage.getItem('Email'),
            'Company name': response && response.data[0].job_metadata.postPosition.companyName,
            'Position name': response && response.data[0].job_metadata.title,
            'Job id': value.jobId,
            'Job role': response && response.data[0].job_metadata.jobRole.name,
            'Active position': response && response.data[0].job_metadata.resourceCount - response.data[0].job_metadata.closedCount - response.data[0].job_metadata.lossCount,
            'Experience': `${response && response.data[0].job_metadata.experienceRange && response.data[0].job_metadata.experienceRange.min} - ${response && response.data[0].job_metadata.experienceRange && response.data[0].job_metadata.experienceRange.max} Years`,
            'Company id' : response && response.data[0].company_id,
            'Allocated to': response && response.data[0].allocatedToName,
            'Core skills': response && response.data[0].job_metadata.coreSkills && response.data[0].job_metadata.coreSkills.length > 0 && response.data[0].job_metadata.coreSkills.map((item: any) => item.skillName),
            'Other skills': response && response.data[0].job_metadata.otherSkills && response.data[0].job_metadata.otherSkills.length > 0 && response.data[0].job_metadata.otherSkills.map((item: any) => item.skillName),
            'Job type': response && response.data[0].job_metadata && response.data[0].job_metadata.jobType,
            'Minimum budget' : `${response && response.data[0].job_metadata.minimumBudget} ${response && response.data[0].job_metadata && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
            'Maximum budget' : `${response && response.data[0].job_metadata.maximumBudget} ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
          })
          setMessage("Position reopened")
          displayNotification()
        }
        if(value.action === "close"){
          mixpanelData('New MT - Position closed', {
            'distinct_id': localStorage.getItem('Email'),
            'Company name': response && response.data[0].job_metadata.postPosition.companyName,
            'Position name': response && response.data[0].job_metadata.title,
            'Job id': value.jobId,
            'Job role': response && response.data[0].job_metadata.jobRole.name,
            'Active position': response && response.data[0].job_metadata.resourceCount - response.data[0].job_metadata.closedCount - response.data[0].job_metadata.lossCount,
            'Experience': `${response && response.data[0].job_metadata.experienceRange && response.data[0].job_metadata.experienceRange.min} - ${response && response.data[0].job_metadata.experienceRange && response.data[0].job_metadata.experienceRange.max} Years`,
            'Company id' : response && response.data[0].company_id,
            'Allocated to': response && response.data[0].allocatedToName,
            'Core skills': response && response.data[0].job_metadata.coreSkills && response.data[0].job_metadata.coreSkills.length > 0 && response.data[0].job_metadata.coreSkills.map((item: any) => item.skillName),
            'Other skills': response && response.data[0].job_metadata.otherSkills && response.data[0].job_metadata.otherSkills.length > 0 && response.data[0].job_metadata.otherSkills.map((item: any) => item.skillName),
            'Job type': response && response.data[0].job_metadata && response.data[0].job_metadata.jobType,
            'Minimum budget' : `${response && response.data[0].job_metadata.minimumBudget} ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
            'Maximum budget' : `${response && response.data[0].job_metadata.maximumBudget} ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.currencyType} / ${response && response.data[0].job_metadata && response && response.data[0].job_metadata.billingType}`,
          })
          setMessage("Position closed")
          displayNotification()
        }   
      } 
    })  
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      navigate('/positions')
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
        <div className="dashboardContent">
          <DashboardHeader 
            title={BreadcrumsValues} 
            searchChange={undefined}
            popupMenu={true}
            priority={jobMetadata.priority}
            updatePosition={updatePosition}
            jobStatus={jobStatus}
          />
          <AppliedCandidates 
            jobMetadata={jobMetadata} 
            appliedResources={appliedResources} 
            convert={convert} 
            lossCount={updateLossCount} 
            jobId={jobId}
            getAppliedCandidates={() => getAppliedCandidates(jobId)}
          />
          {modal && <ConfirmationModal onClose={ () => setModal(false)} submit={submit} reject={false}/>} 
          {notification && <NotificationAlert onClose={onClose } closable={true} >
              {message}
          </NotificationAlert> }
        </div>
    </section>
  );
}

export default PositionDetails;
